export const CATALOG_PRODUCTS_PER_BLOCK = 8;
export const DEFAULT_CATALOG_CONTENT_SEQUENCE = ['banner', 'lifestyle'];
export const SECOND_ATTENTION_LOOP_INDEX = 1;

export const buildCatalogFeed = (products = [], options = {}) => {
  const normalizedProducts = Array.isArray(products) ? products : [];
  const chunkSize = Number(options.chunkSize) > 0
    ? Number(options.chunkSize)
    : CATALOG_PRODUCTS_PER_BLOCK;
  const contentSequence = Array.isArray(options.contentSequence) && options.contentSequence.length > 0
    ? options.contentSequence
    : DEFAULT_CATALOG_CONTENT_SEQUENCE;
  const blocks = [];
  let contentIndex = 0;

  for (let start = 0; start < normalizedProducts.length; start += chunkSize) {
    const chunk = normalizedProducts.slice(start, start + chunkSize);

    if (chunk.length === 0) {
      continue;
    }

    blocks.push({
      id: `product-${start}`,
      type: 'product',
      data: chunk,
    });

    if (chunk.length === chunkSize) {
      const type = contentSequence[contentIndex % contentSequence.length];
      const resolvedType = contentIndex === SECOND_ATTENTION_LOOP_INDEX ? 'video' : type;

      blocks.push({
        id: `${resolvedType}-${contentIndex}`,
        type: resolvedType,
        sequenceIndex: contentIndex,
      });

      contentIndex += 1;
    }
  }

  return blocks;
};

export default buildCatalogFeed;
